// extracted by mini-css-extract-plugin
export var avatarContainer = "_9y-0";
export var avatarTypingWave = "_9y-i";
export var gray = "_9y-f";
export var green = "_9y-c";
export var icon = "_9y-9";
export var image = "_9y-1";
export var lg = "_9y-6";
export var md = "_9y-5";
export var presenceDot = "_9y-b";
export var red = "_9y-d";
export var sm = "_9y-4";
export var status = "_9y-a";
export var typingDot = "_9y-h";
export var typingPill = "_9y-g";
export var xl = "_9y-7";
export var xs = "_9y-3";
export var xxl = "_9y-8";
export var xxs = "_9y-2";
export var yellow = "_9y-e";